import { sheet } from "./app.css.js";
import { bootstrap, theme, viewTransition } from "./styles";
import { provide } from "../services/di";
import { NavBar } from "./components/nav-bar";
import { ChartServiceImpl } from "../services/chart-data";
import { MusicPlayServiceImpl } from "../services/music-play";
import { ProfileServiceImpl } from "../services/player-profile";
import { $Router, Router } from "./pages/router";
import { routes } from "./pages";
import { WorldModeServiceImpl } from "../services/world-mode";
import { element } from "hyplate";
import { Container } from "classic-di";
import { AssetsServiceImpl } from "../services/assets";
import { AssetsResolverImpl } from "../services/assets-resolver";
import { PreferenceServiceImpl } from "../services/preference";
import { ArcaeaToolbeltDatabaseContext } from "../services/database";
import { CharacterServiceImpl } from "../services/character";
import { ProxyGateway } from "../services/gateway";
import { AssetsCacheServiceImpl } from "../services/assets-cache";
import { CoreDataServiceImpl } from "../services/core-data";
import { CoreDataProviderImpl } from "../services/core-data-provider.js";
import { FileStorageServiceImpl } from "../services/file-storage.js";
import { StorageLogger } from "../services/log.js";
import { $LowLevelStorage } from "../services/declarations.js";
document.adoptedStyleSheets = [bootstrap, theme, viewTransition, sheet];

const ioc = new Container();
ioc.add($LowLevelStorage, sessionStorage);
ioc.register(StorageLogger);
ioc.register(CharacterServiceImpl);
ioc.register(ArcaeaToolbeltDatabaseContext);
ioc.register(PreferenceServiceImpl);
ioc.register(AssetsCacheServiceImpl);
ioc.register(FileStorageServiceImpl);
ioc.register(ProxyGateway);
ioc.register(CoreDataServiceImpl);
ioc.register(CoreDataProviderImpl);
ioc.register(AssetsResolverImpl);
ioc.register(AssetsServiceImpl);
ioc.register(ChartServiceImpl);
ioc.register(MusicPlayServiceImpl);
ioc.register(ProfileServiceImpl);
ioc.register(WorldModeServiceImpl);
const main = element("main");
const router = new Router(main, routes, routes[0]!);
ioc.add($Router, router);
provide(document.body, ioc);

document.body.append(new NavBar(), main);
